import React from 'react';
import { Link } from 'react-router-dom';
import NavSubMenu from './NavSubMenu';

const NavAdminMenu = props => {
  return (
    <ul className="nav-menu-list">
      <li className="nav-menu-list-item">
        <Link to="/admin/services" className="a--blue">
          Calendar
        </Link>
      </li>
      <li className="nav-menu-list-item">
        <Link to="/admin/clients" className="a--blue">
          Clients
        </Link>
      </li>
      <li className="nav-menu-list-item">
        <Link to="/admin/chefs" className="a--blue">
          Chefs
        </Link>
      </li>
      <li className="nav-menu-list-item">
        <NavSubMenu label="Culinary" Content={MenuManagementContent} />
      </li>
      <li className="nav-menu-list-item">
        <a href={process.env.REACT_APP_CS_DASH_LINK || 'https://culinistas.backboard.work'} className="a--blue">
          CS Dashboard
        </a>
      </li>
    </ul>
  );
};

const MenuManagementContent = props => {
  return (
    <ul
      className={`nav-sub-menu ${props.isOpen ? 'nav-sub-menu--active' : ''}`}
    >
      <li className="nav-sub-menu-item">
        <Link to="/admin/menus/weekly" className="a--blue">
          Menu Library
        </Link>
      </li>
      <li className="nav-sub-menu-item">
        <Link to="/admin/dishes" className="a--blue">
          Dish Library
        </Link>
      </li>
      <li className="nav-sub-menu-item">
        <Link to="/admin/products" className="a--blue">
          Product Library
        </Link>
      </li>
    </ul>
  );
};

export default NavAdminMenu;



// WEBPACK FOOTER //
// ./src/components/nav/NavAdminMenu.js